import styled from "styled-components";

export const CloudContainer = styled.div`
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 80px 0;

  @media (max-width: 1920px) {
    padding: 60px 0;
    gap: 30px;
  }

  @media (max-width: 1440px) {
    padding: 50px 0;
    gap: 25px;
  }

  @media (max-width: 1024px) {
    padding: 40px 0;
    gap: 20px;
  }

  @media (max-width: 768px) {
    padding: 30px 0;
    gap: 15px;
  }
`;

export const TextContainer = styled.div`
  padding: 0 80px;

  @media (max-width: 1920px) {
    padding: 0 60px;
  }

  @media (max-width: 1440px) {
    padding: 0 50px;
  }

  @media (max-width: 1024px) {
    padding: 0 40px;
  }

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const CloudTitle = styled.h2`
  font-size: 56px;
  font-weight: 700;
  font-family: "Pretendard";
  line-height: 1.4;
  margin-bottom: 20px;
  color: #000;
  text-align: left;

  @media (max-width: 1920px) {
    font-size: 48px;
  }

  @media (max-width: 1440px) {
    font-size: 36px;
  }

  @media (max-width: 1024px) {
    font-size: 32px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const CloudSubTitle = styled.p`
  font-size: 32px;
  font-weight: 600;
  font-family: "Pretendard";
  color: #666;
  line-height: 1.5;
  margin-bottom: 0;
  max-width: 900px;
  text-align: left;

  @media (max-width: 1920px) {
    font-size: 24px;
  }

  @media (max-width: 1440px) {
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    width: 55%;
    margin: 0;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    width: 55%;
  }
`;

export const CloudImage = styled.img`
  width: 100%;
  max-width: 1500px;
  height: auto;
  display: block;
  margin: 0 auto;

  @media (max-width: 768px) {
    border-radius: 0;
  }
`;
